import { useEffect } from 'react';

import { useAppDispatch } from 'src/app/store/hooks';
import { useProfileRetrieveQuery } from 'src/common/external/bambi-api/bambiApi';

import { authSlice } from './auth.slice';
import { authService } from './authService';

export function useFetchAndEnsureProfile() {
  const dispatch = useAppDispatch();
  const { data: profile, isLoading, error } = useProfileRetrieveQuery();

  useEffect(() => {
    if (profile) {
      dispatch(authSlice.actions.signIn(profile));
    }
  }, [profile, dispatch]);

  if (error) {
    authService.signOut();
  }

  return {
    isLoading,
  };
}
